import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FaPen } from 'react-icons/fa';
import '../../styles/user/profileInfo.css';

const ProfilePage = React.memo(({
  profileData,
  handleProfileChange,
  handleCancelEdit,
  handleSaveProfile,
}) => {
  const [isEditingPhone, setIsEditingPhone] = useState(false);
  const [tempPhoneNumber, setTempPhoneNumber] = useState(profileData.phonenumber);

  const handlePhoneChange = (e) => {
    const onlyNumbers = e.target.value.replace(/\D/g, '');
    const maxTenDigits = onlyNumbers.slice(0, 10);
    setTempPhoneNumber(maxTenDigits);
  };

  const cancelEdit = () => {
    setTempPhoneNumber(profileData.phonenumber); // Reset to original number
    setIsEditingPhone(false);
    handleCancelEdit();
  };

  const updatePhone = () => {
    handleProfileChange({
      target: {
        name: 'phonenumber',
        value: tempPhoneNumber,
      }
    });
    handleSaveProfile();
    setIsEditingPhone(false);
  };

  return (
    <motion.div
      className="profile-wrapper"
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, ease: 'easeOut' }}
    >
      <div className="profile-header">Profile Information</div>

      <div className="profile-card">
        <div className="info-group">
          <label>Name:</label>
          <p>{profileData.username}</p>
        </div>

        <div className="info-group">
          <label>Company Name:</label>
          <p>{profileData.companyname}</p>
        </div>

        <div className="info-group">
          <label>Email Id:</label>
          <p>{profileData.personalemail}</p>
        </div>

        <div className="form-group info-group">
          <label>Phone Number:</label>

          {isEditingPhone ? (
            <>
              <input
                type="text"
                name="phonenumber"
                value={tempPhoneNumber}
                onChange={handlePhoneChange}
              />
              <div className="form-buttons">
                <button className="cancel-btn" onClick={cancelEdit}>Cancel</button>
                <button className="save-btn" onClick={updatePhone}>Update</button>
              </div>
            </>
          ) : (
            <div className="phone-display">
              <span>{profileData.phonenumber}</span>
              <FaPen className="edit-pen-icon" onClick={() => {
                setTempPhoneNumber(profileData.phonenumber);
                setIsEditingPhone(true);
              }} />
            </div>
          )}
        </div>
      </div>
    </motion.div>
  );
});

export default ProfilePage;
